export const ralColors = [
  { code: "1000", name: "Groenbeige", hex: "#D0C8B0" },
  { code: "1001", name: "Beige", hex: "#EAE6CA" },
  { code: "1002", name: "Zandgeel", hex: "#E3D9C6" },
  { code: "1003", name: "Signaalgeel", hex: "#F6B90A" },
  { code: "1004", name: "Goudgeel", hex: "#E5A90A" },
  { code: "1005", name: "Honinggeel", hex: "#DDAF27" },
  { code: "1006", name: "Maisgeel", hex: "#E3A857" },
  { code: "1007", name: "Narcisgeel", hex: "#F5A300" },
  { code: "1011", name: "Bruinbeige", hex: "#D6AE74" },
  { code: "1012", name: "Citroengeel", hex: "#F3D54D" },
  { code: "1013", name: "Parelwit", hex: "#F4F4F0" },
  { code: "1014", name: "Ivoor", hex: "#F0EADA" },
  { code: "1015", name: "Lichtivoor", hex: "#F2E8D5" },
  { code: "1016", name: "Zwavelgeel", hex: "#F3E500" },
  { code: "1017", name: "Saffraangeel", hex: "#F5A900" },
  { code: "1018", name: "Zinkgeel", hex: "#F8C300" },
  { code: "1019", name: "Grijsbeige", hex: "#B9A28A" },
  { code: "1020", name: "Olijfgeel", hex: "#A38C15" },
  { code: "1021", name: "Koolzaadgeel", hex: "#FAD201" },
  { code: "1023", name: "Verkeersgeel", hex: "#F5A700" },
  { code: "1024", name: "Okergeel", hex: "#C08F32" },
  { code: "1026", name: "Lichtgeel", hex: "#F7F000" },
  { code: "1027", name: "Chroomgeel", hex: "#FFE500" },
  { code: "1028", name: "Melisgeel", hex: "#FFDB00" },
  { code: "1032", name: "Goudbruin", hex: "#B88A50" },
  { code: "1033", name: "Zonnegeel", hex: "#F39F18" },
  { code: "1034", name: "Pastelgeel", hex: "#EDB315" },
  { code: "1035", name: "Parelmoergoud", hex: "#D9A441" },
  { code: "1036", name: "Parelmoerlichtgoud", hex: "#EB9E52" },
  { code: "1037", name: "Dieporanje", hex: "#DA6E00" },
  { code: "2000", name: "Geeloranje", hex: "#E25303" },
  { code: "2001", name: "Roodoranje", hex: "#DF440D" },
  { code: "2002", name: "Vermiljoen", hex: "#E13E28" },
  { code: "2003", name: "Pasteloranje", hex: "#F44600" },
  { code: "2004", name: "Zuiver oranje", hex: "#FF4200" },
  { code: "2005", name: "Helder oranje", hex: "#FF5B00" },
  { code: "2007", name: "Licht oranje", hex: "#FF7F00" },
  { code: "2008", name: "Signaaloranje", hex: "#F54021" },
  { code: "2009", name: "Verkeersoranje", hex: "#EC542F" },
  { code: "2010", name: "Zalmoranje", hex: "#E55137" },
  { code: "2011", name: "Perzikkleurig", hex: "#E4A686" },
  { code: "2012", name: "Parelmoeroranje", hex: "#E1CCB1" },
  { code: "3000", name: "Vuurrood", hex: "#AF2B1E" },
  { code: "3001", name: "Signaalrood", hex: "#A52019" },
  { code: "3002", name: "Karmijnrood", hex: "#9B111E" },
  { code: "3003", name: "Robijnrood", hex: "#8F0F1D" },
  { code: "3004", name: "Purperrood", hex: "#75151E" },
  { code: "3005", name: "Wijnrood", hex: "#5E1919" },
  { code: "3007", name: "Zwartrood", hex: "#221B1B" },
  { code: "3009", name: "Oxiderood", hex: "#A22623" },
  { code: "3011", name: "Bruinrood", hex: "#7A2225" },
  { code: "3012", name: "Beigerood", hex: "#9B5E5C" },
  { code: "3013", name: "Tomatenrood", hex: "#8C1B2F" },
  { code: "3014", name: "Oudroze", hex: "#C6846D" },
  { code: "3015", name: "Lichtroze", hex: "#D36E70" },
  { code: "3016", name: "Koraalrood", hex: "#A63D4B" },
  { code: "3017", name: "Rozerood", hex: "#CB555D" },
  { code: "3018", name: "Aardbeirood", hex: "#C73F4A" },
  { code: "3020", name: "Verkeersrood", hex: "#BB1E10" },
  { code: "3022", name: "Zalmrood", hex: "#CF6955" },
  { code: "3024", name: "Lichtrood", hex: "#FF2D21" },
  { code: "3026", name: "Fluorescerend rood", hex: "#FF2A13" },
  { code: "3027", name: "Framboosrood", hex: "#AB273C" },
  { code: "3028", name: "Zuiverrood", hex: "#CC2C24" },
  { code: "3031", name: "Orientrood", hex: "#A63437" },
  { code: "3032", name: "Parelmoerrood", hex: "#701D23" },
  { code: "3033", name: "Parelmoerlichtrood", hex: "#A53B2D" },
  { code: "4001", name: "Roodlila", hex: "#816183" },
  { code: "4002", name: "Roodpaars", hex: "#8D3C4B" },
  { code: "4003", name: "Heidepaars", hex: "#C4618C" },
  { code: "4004", name: "Bordeauxpaars", hex: "#651E38" },
  { code: "4005", name: "Blauwlila", hex: "#76689A" },
  { code: "4006", name: "Verkeerspurper", hex: "#903373" },
  { code: "4007", name: "Paars", hex: "#47243C" },
  { code: "4008", name: "Signaalpaars", hex: "#844C82" },
  { code: "4009", name: "Pastelpaars", hex: "#9D8692" },
  { code: "4010", name: "Telemagenta", hex: "#C60058" },
  { code: "4011", name: "Parelmoerdonkerviolet", hex: "#A18594" },
  { code: "4012", name: "Parelmoerlichtviolet", hex: "#C9ADA1" },
  { code: "5000", name: "Paarsblauw", hex: "#2A2C41" },
  { code: "5001", name: "Groenblauw", hex: "#1E213D" },
  { code: "5002", name: "Ultramarijnblauw", hex: "#18171C" },
  { code: "5003", name: "Saffierblauw", hex: "#1E2460" },
  { code: "5004", name: "Zwartblauw", hex: "#3E5F8A" },
  { code: "5005", name: "Signaalblauw", hex: "#252C7C" },
  { code: "5007", name: "Brillantblauw", hex: "#41678D" },
  { code: "5008", name: "Grijsblauw", hex: "#313C48" },
  { code: "5009", name: "Azuurblauw", hex: "#2E5978" },
  { code: "5010", name: "Gentiaanblauw", hex: "#13447C" },
  { code: "5011", name: "Staalblauw", hex: "#232C3F" },
  { code: "5012", name: "Lichtblauw", hex: "#2986CC" },
  { code: "5013", name: "Kobaltblauw", hex: "#0E294B" },
  { code: "5014", name: "Duifblauw", hex: "#4D6F97" },
  { code: "5015", name: "Hemelsblauw", hex: "#2186BA" },
  { code: "5017", name: "Verkeersblauw", hex: "#0D4F8B" },
  { code: "5018", name: "Turkooisblauw", hex: "#1A5784" },
  { code: "5019", name: "Capriblauw", hex: "#0B4152" },
  { code: "5020", name: "Oceaanblauw", hex: "#0F5688" },
  { code: "5021", name: "Waterblauw", hex: "#1C6686" },
  { code: "5022", name: "Nachtsblauw", hex: "#152532" },
  { code: "5023", name: "Verblauw", hex: "#49678D" },
  { code: "5024", name: "Pastelblauw", hex: "#5D9B9B" },
  { code: "5025", name: "Parelmoerblauw", hex: "#2A6478" },
  { code: "5026", name: "Parelmoernachtblauw", hex: "#0D7EB8" },
  { code: "6000", name: "Patinagroen", hex: "#3A7460" },
  { code: "6001", name: "Smaragdgroen", hex: "#366735" },
  { code: "6002", name: "Loofgroen", hex: "#325928" },
  { code: "6003", name: "Olijfgroen", hex: "#50533C" },
  { code: "6004", name: "Blauwgroen", hex: "#024442" },
  { code: "6005", name: "Mosgroen", hex: "#2D4030" },
  { code: "6006", name: "Grijsolijfgroen", hex: "#424632" },
  { code: "6007", name: "Flessengroen", hex: "#2C5545" },
  { code: "6008", name: "Bruingroen", hex: "#39352A" },
  { code: "6009", name: "Dennengroen", hex: "#343B29" },
  { code: "6010", name: "Grasgroen", hex: "#39513E" },
  { code: "6011", name: "Resedagroen", hex: "#4B6D41" },
  { code: "6012", name: "Zwartgroen", hex: "#1E3A2F" },
  { code: "6013", name: "Rietgroen", hex: "#5C705E" },
  { code: "6014", name: "Geelolijfgroen", hex: "#47402E" },
  { code: "6015", name: "Zwartolijfgroen", hex: "#3B3C36" },
  { code: "6016", name: "Turkooisgroen", hex: "#1E5945" },
  { code: "6017", name: "Meigroen", hex: "#4D6F39" },
  { code: "6018", name: "Geelgroen", hex: "#6C7C59" },
  { code: "6019", name: "Witgroen", hex: "#D4D8D1" },
  { code: "6020", name: "Chroomoxidegroen", hex: "#2D3D36" },
  { code: "6021", name: "Bleekgroen", hex: "#7D8B55" },
  { code: "6022", name: "Bruinolijfgroen", hex: "#474135" },
  { code: "6024", name: "Verkeersgroen", hex: "#308446" },
  { code: "6025", name: "Varengroen", hex: "#3D642D" },
  { code: "6026", name: "Opalgroen", hex: "#0F4336" },
  { code: "6027", name: "Lichtgroen", hex: "#C8E3C7" },
  { code: "6028", name: "Pijnboomgroen", hex: "#2E554A" },
  { code: "6029", name: "Mintgroen", hex: "#277D66" },
  { code: "6032", name: "Signaalgroen", hex: "#1F8A59" },
  { code: "6033", name: "Mintturkoois", hex: "#365F4A" },
  { code: "6034", name: "Pastelturkoois", hex: "#7FB5B5" },
  { code: "6035", name: "Parelmoerdonkergroen", hex: "#1F3A3D" },
  { code: "6036", name: "Parelmoerlichtgroen", hex: "#C9D9CD" },
  { code: "6037", name: "Zuivergroen", hex: "#008F39" },
  { code: "6038", name: "Felgroen", hex: "#00BB2D" },
  { code: "7000", name: "Pelsgrijs", hex: "#78858B" },
  { code: "7001", name: "Zilvergrijs", hex: "#8A9597" },
  { code: "7002", name: "Olijfgrijs", hex: "#7E7B52" },
  { code: "7003", name: "Mosgrijs", hex: "#6C7059" },
  { code: "7004", name: "Signaalgrijs", hex: "#969992" },
  { code: "7005", name: "Muisgrijs", hex: "#5F6259" },
  { code: "7006", name: "Beigegrijs", hex: "#575D57" },
  { code: "7008", name: "Khakigrijs", hex: "#4D5645" },
  { code: "7009", name: "Groengrijs", hex: "#4C514A" },
  { code: "7010", name: "Zeildoekgrijs", hex: "#434B4D" },
  { code: "7011", name: "IJzergrijs", hex: "#4E5452" },
  { code: "7012", name: "Bazaltgrijs", hex: "#464531" },
  { code: "7013", name: "Bruingrijs", hex: "#434750" },
  { code: "7015", name: "Leigrijs", hex: "#4D5D5B" },
  { code: "7016", name: "Antracietgrijs", hex: "#3E3B32" },
  { code: "7021", name: "Zwartgrijs", hex: "#262C2A" },
  { code: "7022", name: "Umbragrijs", hex: "#332F2C" },
  { code: "7023", name: "Betongrijs", hex: "#878A85" },
  { code: "7024", name: "Grafietgrijs", hex: "#474A51" },
  { code: "7026", name: "Granietgrijs", hex: "#2F353B" },
  { code: "7030", name: "Steengrijs", hex: "#8B8C7A" },
  { code: "7031", name: "Blauwgrijs", hex: "#5D6970" },
  { code: "7032", name: "Kiezelgrijs", hex: "#6C6960" },
  { code: "7033", name: "Cementgrijs", hex: "#9C9C9C" },
  { code: "7034", name: "Geelgrijs", hex: "#7E7B6E" },
  { code: "7035", name: "Lichtgrijs", hex: "#C5C7C4" },
  { code: "7036", name: "Platinagrijs", hex: "#8F8B66" },
  { code: "7037", name: "Stofgrijs", hex: "#7F7F7E" },
  { code: "7038", name: "Agaatgrijs", hex: "#B5B8B1" },
  { code: "7039", name: "Kwartsgrijs", hex: "#6C6E6B" },
  { code: "7040", name: "Venstergrijs", hex: "#9DA1AA" },
  { code: "7042", name: "Verkeersgrijs A", hex: "#8D948D" },
  { code: "7043", name: "Verkeersgrijs B", hex: "#4E5452" },
  { code: "7044", name: "Zijdegrijs", hex: "#BDBDB7" },
  { code: "7045", name: "Telegrijs 1", hex: "#91969A" },
  { code: "7046", name: "Telegrijs 2", hex: "#82898E" },
  { code: "7047", name: "Telegrijs 4", hex: "#CFD0CF" },
  { code: "7048", name: "Parelmoergrijs", hex: "#888175" },
  { code: "8000", name: "Groenbruin", hex: "#826C34" },
  { code: "8001", name: "Okerbruin", hex: "#955F20" },
  { code: "8002", name: "Signaalbruin", hex: "#6C3B2A" },
  { code: "8003", name: "Leembruin", hex: "#734222" },
  { code: "8004", name: "Koperbruin", hex: "#8E402A" },
  { code: "8007", name: "Reebruin", hex: "#59351F" },
  { code: "8008", name: "Olijfbruin", hex: "#6F4F28" },
  { code: "8011", name: "Nussbaum", hex: "#5B3A29" },
  { code: "8012", name: "Roodbruin", hex: "#592321" },
  { code: "8014", name: "Sepiabruin", hex: "#382C1E" },
  { code: "8015", name: "Kastanjebruin", hex: "#633A34" },
  { code: "8016", name: "Mahoniebruin", hex: "#4C2F27" },
  { code: "8017", name: "Chocoladebruin", hex: "#45322E" },
  { code: "8019", name: "Grijsbruin", hex: "#403A3A" },
  { code: "8022", name: "Zwartbruin", hex: "#212121" },
  { code: "8023", name: "Oranjebruin", hex: "#A65E2E" },
  { code: "8024", name: "Beigebruin", hex: "#79553D" },
  { code: "8025", name: "Bleekbruin", hex: "#755C48" },
  { code: "8028", name: "Terrabruin", hex: "#4E3B31" },
  { code: "8029", name: "Parelmoerkoper", hex: "#763C28" },
  { code: "9001", name: "Crèmewit", hex: "#F8F4E6" },
  { code: "9002", name: "Grijslicht", hex: "#E7EBDA" },
  { code: "9003", name: "Signaalwit", hex: "#F4F4F4" },
  { code: "9004", name: "Signaalzwart", hex: "#0E0E0E" },
  { code: "9005", name: "Gitzwart", hex: "#0A0A0A" },
  { code: "9006", name: "Wit aluminium", hex: "#A5A5A5" },
  { code: "9007", name: "Grijs aluminium", hex: "#8F8F8F" },
  { code: "9010", name: "Zuiverwit", hex: "#FFFFFF" },
  { code: "9011", name: "Grafietzwart", hex: "#1C1C1C" },
  { code: "9016", name: "Verkeerswit", hex: "#F6F6F6" },
  { code: "9017", name: "Verkeerszwart", hex: "#1E1E1E" },
  { code: "9018", name: "Papyruswit", hex: "#DEDED4" },
  { code: "9022", name: "Parelmoerlichtgrijs", hex: "#9C9C9C" },
  { code: "9023", name: "Parelmoerdonkergrijs", hex: "#7E7E7E" }
];